import Requests from "../../../utils/Requests"
import Validation from '../../../data/validation/validation'
import { NumberValidationRule, StringValidationRule } from '../../../data/validation/rules'
import { ScrollIntoFirstError } from "../../../utils/UIHelper"

const getDefaultState = () => {
    return {
        loadingObligations: false,
        loadingWallet: false,
        processingPayment: false,
        obligations: [],
        selectedObligation: null,
        wallet: {
            credit: 0,
            debit: 0,
            balance: 0,
            dvn: null
        },
        tab: 0,
        amount: 0,
        remarks: "",
        reference: "",
        errors: {},
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0
    }
}

const loadObligations = instance => {

    if (instance.state.loadingObligations) {
        return
    }

    instance.setState({
        ...instance.state,
        loadingObligations: true
    })

    const data = {
        page: instance.state.currentPage,
        size: instance.state.itemsPerPage,
        criteria: []
    }

    Requests(instance.props)
        .withPost()
        .withData(data)
        .withUrl('/api/finance/member/obligations')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleLoadObligationsResponse(instance, response), error => handleError(instance, error))
}

const handleLoadObligationsResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingObligations: false,
                obligations: response.data.obligations,
                totalItems: response.data.size
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingObligations: false
            })
            alert(response.message)
    }
}

const loadWallet = instance => {

    if (instance.state.loadingWallet) {
        return
    }

    instance.setState({
        ...instance.state,
        loadingWallet: true
    })

    Requests(instance.props)
        .withPost()
        .withData({})
        .withUrl('/api/finance/wallet')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleLoadWalletResponse(instance, response), error => handleError(instance, error))
}

const handleLoadWalletResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingWallet: false,
                wallet: response.data.wallet
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingWallet: false
            })
            alert(response.message)
    }
}

const processPayment = instance => {

    if(instance.state.processingPayment){
        return
    }

    instance.setState({
        ...instance.state,
        processingPayment: true
    })

    let data = {
        id: instance.state.selectedObligation.id,
        amount: instance.state.amount * 100,
        remarks: instance.state.remarks
    }

    Requests(instance.props)
        .withPost()
        .withData(data)
        .withUrl('/api/finance/member/obligation/pay')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleProcessPaymentResponse(instance, response), error => handleError(instance, error))
}

const handleProcessPaymentResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                processingPayment: false,
                remarks: 0,
                reference: response.data.transaction.reference,
                tab: 2
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                processingPayment: false,
                flag: {
                    type: "error",
                    text: response.message
                }
            })
            alert(response.message)
    }
}

const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        loadingObligations: false,
        processingPayment: false,
        loadingWallet: false,
        flag: {
            type: "",
            text: ""
        }
    })

    alert(error)

}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(NumberValidationRule, instance.state.amount, (error) => instance.state.errors.amount = error, { min: { value: instance.state.selectedObligation.amount, error: "Invalid" }, max: { value: 9999999, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.remarks, (error) => instance.state.errors.remarks = error, { min: { value: 0, error: "Invalid" }, max: { value: 40, error: "Invalid" } })

    let validate = validation.validate()
    let stateUpdate = {
        errors: errors
    }

    ScrollIntoFirstError(errors)
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })

    return validate
}

const Service = instance => {
    return {
        loadObligations: () => loadObligations(instance),
        isValid: () => isValid(instance),
        loadWallet: () => loadWallet(instance),
        processPayment: () => processPayment(instance),
        getDefaultState: () => getDefaultState()
    }
}

export default Service